module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vresp4-9272c99c5ee73a5c5a0787684a536a84.jpg";